__turbopack_context__.v({
  "modalRoot": "PartnerTypeformModal-module__S8DZMW__modalRoot",
  "typeformContainer": "PartnerTypeformModal-module__S8DZMW__typeformContainer",
});
